import { Component, OnInit, signal } from "@angular/core";
import { PqvDashboardService } from "../services/pqvDashboard.services";
import { Modal } from 'bootstrap'
import { CupService } from "../../../shared/services/cup.service";
import { urls } from "../../../common/model/properties";
import { ProviderportalService } from "../../providerportal.service";
import { saveAs } from "file-saver";
import { DateRange } from "../clinical-visit/clinical-visit.component";

@Component({
    selector: 'app-patientdashboard',
    templateUrl: './patientdashboard.component.html',
    styleUrl: './patientdashboard.component.scss',
    standalone: false
})
export class PatientDashboardComponent implements OnInit {
    constructor(
        private pqvService: PqvDashboardService,
        private cupService: CupService
    ) {

    }
    fileData:any = [];
    data: any;
    memId:any;
    showSpinner = false;
    memberDetails: any;
    memberLabDetails = signal<any[] | null>(null);
    memberMedicationDetails: any[] = [];
    memberAge: number;
    selectedRange?: DateRange;
    searchDate: boolean = false;

    handleResults(searchObj) {
        this.data = searchObj;
    }
    ngOnInit() {
        this.getMemberDetails();
    }
    getMemberDetails() {
        this.memberDetails = this.pqvService.memberDetails();
        if (this.memberDetails != null) {
            this.memberAge = this.calculateAge(this.memberDetails.memberDOB)
            this.proccedTogetData(this.memberDetails);

        } else {
            this.openModal("dataNotAvailableModal")
        }
    }
    proccedTogetData(memberDetails: any) {
        this.getMedicationData(memberDetails.memberHmoID);

    }
    getMedicationData(memberId: any) {
        this.showSpinner = true;
        this.pqvService.getMedicationDetails(memberId).subscribe((res) => { //"023I17705"
            if (res && res.memberPharmacyDetails.length > 0) {
                for (const el of res.memberPharmacyDetails) {
                    for (const pharmacyData of el.pharmacyDetails) {
                        this.memberMedicationDetails.push(pharmacyData);
                    }

                }

                this.getLabDeatailsData(memberId);
            } else {
                this.memberMedicationDetails = [];
                this.getLabDeatailsData(memberId);
            }
        }, (error) => {
            this.memberMedicationDetails = [];
            this.getLabDeatailsData(memberId);
            console.log(error);
        });
    }
    getClinicalDocs(memberId,dob){
        this.fileData = [];
        this.memId = memberId;
        let ResponseData: any;
        let body = {
            "memberId": memberId, //"371M97362",
            "DOB": dob, // "07/26/1961",
            "memberActive": "All",
           //"lastName": ln[1], //"CHURCH" // "AGUEDA ROSSI",
          }
        this.showSpinner = true;
        let currentDate = new Date()
        let currentDateStr = this.pqvService.formatDate(currentDate)

        let fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 90);
        let fromDateStr = this.pqvService.formatDate(fromDate);

        let fileList = [];
        this.showSpinner = true; //
        this.pqvService.getListOfEncounters(memberId, fromDateStr, currentDateStr).subscribe(data => {
            let resp: any = data;
            let eachFile: any = {}
            if (resp.hasOwnProperty('encounters')) {
                ResponseData = resp['encounters'];
            } else {
                //ResponseData = resp;
            }
            //console.log("ResponseData-- :", ResponseData);
            ResponseData.forEach(ResponseData => {
                ResponseData.memberName = ResponseData.providerlastname + ", " + ResponseData.providerfirstname;
            });

            //console.log("ResponseData--1 :", ResponseData);
            this.fileData = ResponseData;
            this.showSpinner = false;

        }, (error) => {
            this.showSpinner = false;
            console.log(error);
        });
        

    }
    getLabDeatailsData(memberId: any) {

        this.pqvService.getLAbDetailsData(memberId).subscribe((res) => {  //"023I17705"
            if (res && res.memberLabDetails.length > 0) {
                
                this.memberLabDetails.set(res);
                this.showSpinner = false;
            } else {
                this.memberLabDetails.set(null);
                this.showSpinner = false;
            }
            this.getClinicalDocs(memberId,this.memberDetails.memberDOB)
        }, (error) => {
            this.memberLabDetails.set(null);
            this.showSpinner = false;
            this.getClinicalDocs(memberId,this.memberDetails.memberDOB)
            console.log(error);
        });
    }
    calculateAge(dob: string): number {
        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();

        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return age;
    }



    openModal(modalId: string) {
        const modal = new Modal(document.getElementById(modalId));
        modal.show();
    }

    closeModal(modalId: string) {
        const modalElement = document.getElementById(modalId);
        const modal = Modal.getInstance(modalElement);
        if (modal != null) {
            modal.hide();
        }
    }

    handleDateChange(range: DateRange) {
    this.selectedRange = range;
    let ResponseData: any;
        let fd = this.pqvService.formatDate(range.fromDate);
        let td = this.pqvService.formatDate(range.toDate);
        //console.log('Received range:', fd, 'to', td);
        this.showSpinner = true;
        this.pqvService.getListOfEncounters(this.memId, fd, td).subscribe(data => {
            let resp: any = data;            
            if (resp.hasOwnProperty('encounters')) {
                ResponseData = resp['encounters'];
            } else {
                ResponseData = resp;
            }
            //console.log("ResponseData-- :", ResponseData);
            ResponseData.forEach(ResponseData => {
                ResponseData.memberName = ResponseData.providerlastname + ", " + ResponseData.providerfirstname;
            });
            this.fileData = [...ResponseData];
            this.showSpinner = false;
        })
    }

    receiveRange(range: DateRange) {
        this.showSpinner = true;
        this.selectedRange = range;
         let ResponseData: any;
        let currentDate = new Date()
        let currentDateStr = this.pqvService.formatDate(currentDate)

        let fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 90);
        let fromDateStr = this.pqvService.formatDate(fromDate);

        this.pqvService.getListOfEncounters(this.memId, fromDateStr, currentDateStr).subscribe(data => {
            let resp: any = data;
            let eachFile: any = {}
            if (resp.hasOwnProperty('encounters')) {
                ResponseData = resp['encounters'];
            } else {
                //ResponseData = resp;
                
            }
            //console.log("ResponseData-- :", ResponseData);
            ResponseData.forEach(ResponseData => {
                ResponseData.memberName = ResponseData.providerlastname + ", " + ResponseData.providerfirstname;
            });
            this.fileData = ResponseData;
            this.showSpinner = false;
        })

    }

}